import { checkTypeExhausted } from "Utility";
import { LogoImage, LogoContainer } from "./styles";
import { useState } from "react";

export type LogoType = "Org" | "Tour" | "Tournament";

interface Props {
  id: string | undefined;
  type: LogoType;
  title?: string;
}

export const Logo = ({ id, type, title }: Props) => {
  const [imgSrc, setImgSrc] = useState(
    !!id ? getPath(id, type) : getDefaultPath(type)
  );

  return (
    <LogoContainer>
      <LogoImage
        src={imgSrc}
        title={title}
        onError={() => setImgSrc(getDefaultPath(type))}
      />
    </LogoContainer>
  );
};

const getPath = (id: string, type: LogoType) => {
  switch (type) {
    case "Org":
      return `/images/orgs/${id}/logo.png`;
    case "Tour":
      return `/images/tours/${id}/logo.png`;
    case "Tournament":
      return `/images/tournaments/${id}/logo.png`;
    default:
      return checkTypeExhausted(type);
  }
};

const getDefaultPath = (type: LogoType) => {
  switch (type) {
    case "Org":
      return `/images/orgs/default/logo.png`;
    case "Tour":
      return undefined;
    case "Tournament":
      return undefined;
    default:
      return checkTypeExhausted(type);
  }
};
